import { BackToLoginLink, Rule } from 'components/core-v2'

import { COPY } from '../constants'
import { TwoColumnWithImage } from '../templates/TwoColumnWithImage'

const MainElement = () => (
  <>
    <p className="mb-0">{COPY.twoFactorNotSetup.message}</p>
    <Rule className="my-12" />
    <BackToLoginLink />
  </>
)

export const TwoFactorNotSetUp = () => (
  <TwoColumnWithImage mainElement={<MainElement />} title={COPY.twoFactorNotSetup.title} />
)
